import {combine, createEffect, createEvent, restore} from 'effector';

import {createFactoriesBatch, editFactory} from 'api';
import {
    CreateFactory,
    EditFactoryRaw,
    EditFactoryRequestData,
    FactoriesListRawRow,
} from 'types/profile';

export const addFactoriesBatchFx = createEffect<CreateFactory[], FactoriesListRawRow[]>(
    (factories) => createFactoriesBatch({factories}),
);

export const editFactoryBatchFx = createEffect(editFactory);

export const addFactories = createEvent<CreateFactory[]>();
export const updateFactory = createEvent<{id: number; data: EditFactoryRequestData}>();

export const isEditModalOpenChanged = createEvent<boolean>();
export const isCreateModalOpenChanged = createEvent<boolean>();
export const editDataChanged = createEvent<EditFactoryRaw | null>();

const closeEditModal = isEditModalOpenChanged.filter({
    fn: (value) => !value,
});

export const createModalVisible$ = restore(isCreateModalOpenChanged, false);
export const editModalVisible$ = restore(isEditModalOpenChanged, false);
export const editData$ = restore(editDataChanged, null).reset(closeEditModal);

export const factoryOperationsState$ = combine({
    showCreate: createModalVisible$,
    showEdit: editModalVisible$,
    isEdit: !!editData$,
    editData: editData$,
    createPending: addFactoriesBatchFx.pending,
    editPending: editFactoryBatchFx.pending,
});
